import { createDomain, sample } from 'effector'
import { FormValues } from '~/entities/Company/model'
import { Company } from '~/shared/api'
import { pushFx } from '~/shared/lib/history'
import { logger } from '~/shared/lib/logger'
import { snackbarEnqueued } from '~/shared/lib/notifications'

export const domain = createDomain('features.companies.add')

export const createFx = domain.createEffect<FormValues, Company>({
  async handler(values) {
    const company = new Company(values)

    const result = await company.save()
    return result.getModel() as Company
  },
})

export const formSubmitted = domain.createEvent<FormValues>()
sample({
  clock: formSubmitted,
  target: createFx,
})

sample({
  clock: createFx.doneData,
  fn() {
    return {
      message: 'Организация создана',
      variant: 'success' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: createFx.doneData,
  fn(company: Company) {
    return `/companies/${company.getApiId()}`
  },
  target: pushFx,
})

sample({
  clock: createFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: 'Ошибка при создании организации',
      variant: 'error' as const,
    }
  },
  target: snackbarEnqueued,
})
